export const siteData = {
  company: {
    name: "Happiness in Action",
    tagline: "AI-First Transformation Agency",
    email: "don@happinessinaction.co",
    phone: "+44 333 011 7974",
  },
  hero: {
    headline: "Future-Proof Your Business with AI-First Transformation",
    subheadline: "From intelligent websites to automated workflows—we modernise your business in weeks, not months.",
    ctaText: "Book Your Strategy Call",
    ctaSecondary: "Learn More",
  },
  painPoints: [
    {
      id: 1,
      title: "Outdated Websites",
      description: "Your website looks like it was built in 2010 and doesn't convert visitors into customers.",
      icon: "Globe",
    },
    {
      id: 2,
      title: "Legacy IT Systems",
      description: "Slow, on-premise servers that cost a fortune to maintain and limit remote work.",
      icon: "Server",
    },
    {
      id: 3,
      title: "Manual Admin Tasks",
      description: "Your team spends hours on repetitive tasks that could be automated with AI.",
      icon: "ClipboardList",
    },
  ],
  solutions: [
    {
      id: 1,
      title: "AI-Powered Websites",
      description: "Modern, fast websites with intelligent chatbots that work 24/7.",
      icon: "Sparkles",
    },
    {
      id: 2,
      title: "Cloud Migration",
      description: "Seamless transition to Google Workspace for secure, anywhere access.",
      icon: "Cloud",
    },
    {
      id: 3,
      title: "Intelligent Automation",
      description: "Custom AI agents that handle your repetitive tasks automatically.",
      icon: "Bot",
    },
  ],
  serviceTiers: [
    {
      id: 1,
      name: "The Digital Front Door",
      price: "",
      description: "Perfect for SMEs ready to make a strong first impression online.",
      badge: "Live in 7 Days",
      featureGroups: [
        {
          title: "The Build (7-Day Sprint)",
          features: [
            "First draft in 3 days",
            "Collaborative refinement",
            "Live on day 7",
          ],
        },
        {
          title: "The Tech",
          features: [
            "Mobile-responsive & SEO ready",
            "Integrated WhatsApp & AI Chatbot",
            "Business email matching your domain (no more gmail/hotmail!)",
            "Virtual landline linked to WhatsApp",
          ],
        },
        {
          title: "The Reach",
          features: [
            "Google Local Ads setup",
            "Social feed integration",
          ],
        },
      ],
      highlighted: false,
      ctaText: "Get Started",
    },
    {
      id: 2,
      name: "The Modern Workspace",
      price: "",
      description: "Ideal for businesses ready to ditch legacy systems and go cloud-first with Google.",
      badge: "Most Popular",
      featureGroups: [
        {
          title: "Everything in Tier 1, PLUS:",
          features: [],
        },
        {
          title: "Google Workspace",
          features: [
            "Full Migration (Gmail, Drive, Docs, Sheets)",
            "Secure Cloud File Storage",
            "Google Meet for video conferencing",
          ],
        },
        {
          title: "Operations",
          features: [
            "Replace on-premise IT",
            "Secure Remote Work Setup",
            "Team training & onboarding",
          ],
        },
      ],
      highlighted: true,
      ctaText: "Choose This Plan",
    },
    {
      id: 3,
      name: "The AI Enterprise",
      price: "",
      description: "For ambitious SMEs ready to lead with AI-powered operations.",
      badge: "Enterprise",
      featureGroups: [
        {
          title: "Everything in Tier 2, PLUS:",
          features: [],
        },
        {
          title: "AI Agents",
          features: [
            "Custom AI Agent development",
            "Internal process automation",
          ],
        },
        {
          title: "Security & Management",
          features: [
            "Password management solution",
            "Cybersecurity tools & monitoring",
            "Mobile device management (MDM)",
            "Cloud telephone systems",
          ],
        },
        {
          title: "Strategic Support",
          features: [
            "Workflow optimisation audit",
            "Staff AI training programme",
            "Dedicated success manager",
            "12-month support & updates",
          ],
        },
      ],
      highlighted: false,
      ctaText: "Book Executive Consultation",
    },
  ],
  about: {
    title: "Why Choose Happiness in Action?",
    description: "We're not your typical consultancy. We leverage the latest AI tools to deliver enterprise-grade results at SME-friendly prices—faster and smarter than traditional agencies.",
    stats: [
      { value: "10x", label: "Faster Delivery" },
      { value: "50%", label: "Cost Savings" },
      { value: "24/7", label: "AI Support" },
      { value: "100+", label: "SMEs Transformed" },
    ],
  },
  transformations: [
    {
      id: 1,
      sector: "Retail",
      title: "24/7 Customer Service",
      description: "Integrated AI chat handles 80% of incoming queries instantly, allowing staff to focus on high-value sales.",
      icon: "ShoppingBag",
    },
    {
      id: 2,
      sector: "Logistics & Operations",
      title: "The Paperless Office",
      description: "Full Google Workspace migration reduced admin time by 15 hours a week and secured client data.",
      icon: "FolderSync",
    },
    {
      id: 3,
      sector: "Professional Services",
      title: "Automated Onboarding",
      description: "Custom agents now handle client intake forms and scheduling, reducing lead time by 50%.",
      icon: "UserCheck",
    },
  ],
  team: [
    {
      id: 1,
      name: "Don McCann",
      role: "Founder & Sales Director",
      bio: "With over 20 years of experience leading global development for major firms like Honeywell and Helvar, I bridge the gap between enterprise-grade strategy and SME agility. I help business owners implement the exact AI tools needed to scale without the corporate fluff.",
      avatar: "DM",
      photo: "https://customer-assets.emergentagent.com/job_aifirst-sme/artifacts/5vmwxmen_1731317883576.jpeg",
      linkedin: "https://linkedin.com/in/don-mccann",
    },
    {
      id: 2,
      name: "Caroline Halpin",
      role: "Founder & Marketing Director",
      bio: "With over 15 years of experience working with Google, I am an experienced marketer and business consultant. I specialise in turning complex digital strategies into clear, actionable plans that drive real growth. From SEO and paid media to brand positioning and AI-powered marketing automation, I help SMEs punch above their weight in competitive markets.",
      avatar: "CH",
      photo: "https://customer-assets.emergentagent.com/job_aifirst-sme/artifacts/a7ip1jxi_Caroline%20Pic.jpeg",
      linkedin: "https://linkedin.com/in/caroline-halpin1234",
    },
  ],
  faq: [
    {
      id: 5,
      question: "What do I need to provide for a website in 7 days?",
      answer: "To hit our rapid 7-day deadline, the clock starts once we have your core assets:\n\n• Logo & Branding: (If you have them).\n• Domain Access: So we can push the site live.\n• Insurance Documentation: Required for Google verification.\n• Social Media Access: Logins or 'Admin' access to your relevant accounts (Facebook, Instagram, LinkedIn) so we can integrate your messaging channels.\n\nDon't worry about website text—if you don't have it, we use generative AI to create professional copy for you to review.",
    },
    {
      id: 1,
      question: "How long does a typical project take?",
      answer: "Most projects are completed within 4-8 weeks, depending on complexity. Our AI-powered workflows allow us to deliver much faster than traditional agencies. We'll give you a precise timeline during your strategy call.",
    },
    {
      id: 2,
      question: "Do you work with businesses outside the UK?",
      answer: "Absolutely! We're a remote-first team and work with SMEs across Europe and beyond. Time zones are never an issue—we adapt to your schedule.",
    },
    {
      id: 3,
      question: "What happens after my project is complete?",
      answer: "Every package includes post-launch support (30-90 days depending on tier). After that, we offer ongoing maintenance plans or ad-hoc support as needed. We're invested in your long-term success.",
    },
    {
      id: 4,
      question: "Can you integrate with our existing systems?",
      answer: "Yes! We specialise in connecting modern AI tools with legacy systems. During discovery, we'll audit your current setup and create a seamless integration plan.",
    },
    {
      id: 6,
      question: "What makes you different from other agencies?",
      answer: "We're AI-native, not AI-adjacent. While others are still learning these tools, we've built our entire practice around them. This means faster delivery, lower costs, and solutions that are genuinely cutting-edge.",
    },
  ],
  whatsapp: {
    number: "447507938955",
    message: "Hi! I'm interested in learning more about your AI transformation services.",
  },
  footer: {
    copyright: "© 2026 Happiness in Action. All rights reserved.",
    socialLinks: [
      { name: "LinkedIn", url: "#", icon: "Linkedin" },
      { name: "Twitter", url: "#", icon: "Twitter" },
      { name: "Instagram", url: "#", icon: "Instagram" },
    ],
    quickLinks: [
      { name: "Services", url: "#services" },
      { name: "About", url: "#about" },
      { name: "Contact", url: "#contact" },
    ],
  },
};
